import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { render, unmountComponentAtNode } from 'react-dom';
import { StrictMode } from 'react';
import { ThemeProvider } from '@finam/web-ui-kit';
import { getTheme } from './utils/style/theme';
import Widget from './components/Widget';
export var mount = function mount(element, _a) {
  var _a$theme = _a.theme,
      theme = _a$theme === void 0 ? 'light' : _a$theme,
      variant = _a.variant,
      options = __rest(_a, ["theme", "variant"]);

  render(_jsx(StrictMode, {
    children: _jsx(ThemeProvider, Object.assign({
      theme: getTheme(theme, variant)
    }, {
      children: _jsx(Widget, Object.assign({}, options, {
        variant: variant
      }))
    }))
  }), element);
  return function () {
    return unmountComponentAtNode(element);
  };
};
export default mount;